const Router = require("vue-router");
import i18n from "../utils/i18n";
import loginView from "@/views/Login";

const routes = [
  {
    path: "/login",
    name: "login",
    component: loginView,
    meta: { title: i18n.t("login.login") } //登录不适用懒加载
  }
];

// 实例化
const router = new Router({
  mode: "history", // 把hash模式改成history nginx location / {try_files $uri $uri/ /index.html;}
  base: process.env.BASE_URL,
  routes
});

export default router;
